<template>
  <div class="page-nav-frame">
    <Layout class="pg-layout">
      <Sider
        ref="menuSider"
        class="layout-left"
        hide-trigger
        collapsible
        :collapsed-width="0"
        v-model="isCollapsed"
      >
        <vue-scroll :ops="scrollOption">
          <div class="layout-l-header">
            <div v-if="env.NODE_ENV !== 'production'" class="version-label">
              测试版{{ env.VUE_APP_VERSION }}
            </div>
            <div v-else class="version-label">
              版本{{ env.VUE_APP_VERSION }}
            </div>
            <div class="logo">
              <img src="../assets/images/logo.png" alt="" />
            </div>
          </div>
          <Menu
            :active-name="activeMenuName"
            :open-names="openMenuName"
            width="auto"
            class="layout-l-menu"
          >
            <MenuItem
              name="1-1"
              to="/home"
              v-if="
                b_role.indexOf('backend/home') != -1 ||
                b_role.indexOf('backend/homeDetail') != -1
              "
            >
              查詢快件
            </MenuItem>

            <Submenu
              name="2"
              v-if="
                b_role.indexOf('backend/scanIn') != -1 ||
                b_role.indexOf('backend/scanOut') != -1 ||
                b_role.indexOf('backend/deliverTodo') != -1 ||
                b_role.indexOf('backend/delivered') != -1 ||
                b_role.indexOf('backend/deliverExc') != -1 ||
                b_role.indexOf('backend/deliverClaim') != -1 ||
                b_role.indexOf('backend/bagNumberList') != -1 ||
                b_role.indexOf('backend/pddList') != -1 ||
                b_role.indexOf('backend/scanIn2') != -1 ||
                b_role.indexOf('backend/scanInMore') != -1 ||
                b_role.indexOf('backend/scanInMerchant') != -1 ||
                b_role.indexOf('backend/scanInMerchantBig') != -1 ||
                b_role.indexOf('backend/scanInBig') != -1
              "
            >
              <template slot="title">
                <div>珠海倉庫</div>
              </template>

              <MenuItem
                name="2-1"
                to="/scanIn"
                v-if="b_role.indexOf('backend/scanIn') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描入庫</span>
              </MenuItem>
              <MenuItem
                name="2-13"
                to="/scanInBig"
                v-if="b_role.indexOf('backend/scanInBig') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描入庫(转店)</span>
              </MenuItem>
              <MenuItem
                name="2-8"
                to="/scanIn2"
                v-if="b_role.indexOf('backend/scanIn2') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描入庫（一站式）</span>
              </MenuItem>
              <MenuItem
                name="2-11"
                to="/scanInMerchant"
                v-if="b_role.indexOf('backend/scanInMerchant') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描入庫（合作方）</span>
              </MenuItem>
              <MenuItem
                name="2-12"
                to="/scanInMerchantBig"
                v-if="b_role.indexOf('backend/scanInMerchantBig') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描入庫散件(合作方)</span>
              </MenuItem>
              <MenuItem
                name="2-7"
                to="/scanInMore"
                v-if="b_role.indexOf('backend/scanInMore') != -1"
              >
                <i class="circle-icon"></i>
                <span>多件掃描入庫</span>
              </MenuItem>

              <MenuItem
                name="2-2"
                to="/scanOut"
                v-if="b_role.indexOf('backend/scanOut') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描出庫</span>
              </MenuItem>

              <MenuItem
                name="2-3"
                to="/deliverTodo"
                v-if="b_role.indexOf('backend/deliverTodo') != -1"
              >
                <i class="circle-icon"></i>
                <span>待出庫</span>
              </MenuItem>

              <MenuItem
                name="2-4"
                to="/delivered"
                v-if="b_role.indexOf('backend/delivered') != -1"
              >
                <i class="circle-icon"></i>
                <span>已出庫</span>
              </MenuItem>

              <MenuItem
                name="2-5"
                to="/deliverExc"
                v-if="b_role.indexOf('backend/deliverExc') != -1"
              >
                <i class="circle-icon"></i>
                <span>異常件</span>
              </MenuItem>

              <MenuItem
                name="2-6"
                to="/deliverClaim"
                v-if="b_role.indexOf('backend/deliverClaim') != -1"
              >
                <i class="circle-icon"></i>
                <span>認領件</span>
              </MenuItem>

              <MenuItem
                name="2-9"
                to="/bagNumberList"
                v-if="b_role.indexOf('backend/bagNumberList') != -1"
              >
                <i class="circle-icon"></i>
                <span>大包号列表</span>
              </MenuItem>

              <MenuItem
                name="2-14"
                to="/pddList"
                v-if="b_role.indexOf('backend/pddList') != -1"
              >
                <i class="circle-icon"></i>
                <span>Pdd已入庫列表</span>
              </MenuItem>

              <MenuItem
                name="2-10"
                to="/claimConfirmation"
                v-if="b_role.indexOf('backend/claimConfirmation') != -1"
              >
                <i class="circle-icon"></i>
                <span>認領件確認</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="3"
              v-if="
                b_role.indexOf('backend/macaoScanIn') != -1 ||
                b_role.indexOf('backend/macaoScanOut') != -1 ||
                b_role.indexOf('backend/macaoScanInList') != -1 ||
                b_role.indexOf('backend/macaoScanOutList') != -1 ||
                b_role.indexOf('backend/abnormalList') != -1 ||
                b_role.indexOf('backend/overtimeTaking') != -1 ||
                b_role.indexOf('backend/overtimeWarehouse') != -1 ||
                b_role.indexOf('backend/overtimeCancel') != -1 ||
                b_role.indexOf('backend/transferList') != -1
              "
            >
              <template slot="title">
                <div>澳門倉庫</div>
              </template>

              <MenuItem
                name="3-1"
                to="/macaoScanIn"
                v-if="b_role.indexOf('backend/macaoScanIn') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描入庫</span>
              </MenuItem>

              <MenuItem
                name="3-2"
                to="/macaoScanOut"
                v-if="b_role.indexOf('backend/macaoScanOut') != -1"
              >
                <i class="circle-icon"></i>
                <span>掃描出庫</span>
              </MenuItem>

              <MenuItem
                name="3-3"
                to="/macaoScanInList"
                v-if="b_role.indexOf('backend/macaoScanInList') != -1"
              >
                <i class="circle-icon"></i>
                <span>已入庫</span>
              </MenuItem>

              <MenuItem
                name="3-4"
                to="/macaoScanOutList"
                v-if="b_role.indexOf('backend/macaoScanOutList') != -1"
              >
                <i class="circle-icon"></i>
                <span>已出庫</span>
              </MenuItem>

              <MenuItem
                name="3-5"
                to="/abnormalList"
                v-if="b_role.indexOf('backend/abnormalList') != -1"
              >
                <i class="circle-icon"></i>
                <span>超期回倉件列表</span>
              </MenuItem>

              <MenuItem
                name="3-6"
                to="/overtimeTaking"
                v-if="b_role.indexOf('backend/overtimeTaking') != -1"
              >
                <i class="circle-icon"></i>
                <span>超時件攬收</span>
              </MenuItem>

              <MenuItem
                name="3-7"
                to="/overtimeWarehouse"
                v-if="b_role.indexOf('backend/overtimeWarehouse') != -1"
              >
                <i class="circle-icon"></i>
                <span>超時快件回倉</span>
              </MenuItem>

              <MenuItem
                name="3-8"
                to="/overtimeCancel"
                v-if="b_role.indexOf('backend/overtimeCancel') != -1"
              >
                <i class="circle-icon"></i>
                <span>超時快件核銷</span>
              </MenuItem>

              <MenuItem
                name="3-9"
                to="/transferList"
                v-if="b_role.indexOf('backend/transferList') != -1"
              >
                <i class="circle-icon"></i>
                <span>轉店列表</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="4"
              v-if="
                b_role.indexOf('backend/shopOnShelves') != -1 ||
                b_role.indexOf('backend/shopManage') != -1 ||
                b_role.indexOf('backend/scanSign') != -1 ||
                b_role.indexOf('backend/signTodo') != -1 ||
                b_role.indexOf('backend/signTodoNew2') != -1 ||
                b_role.indexOf('backend/signed') != -1 ||
                b_role.indexOf('backend/stockscanIn') != -1 ||
                b_role.indexOf('backend/stockscanInList') != -1 ||
                b_role.indexOf('backend/overtimeList') != -1 ||
                b_role.indexOf('backend/transferConfirm') != -1 ||
                b_role.indexOf('backend/transferWaiting') != -1
              "
            >
              <template slot="title">
                <div>澳門門店</div>
              </template>

              <MenuItem
                name="4-1"
                to="/shopOnShelves"
                v-if="b_role.indexOf('backend/shopOnShelves') != -1"
              >
                <i class="circle-icon"></i>
                <span>門店上架</span>
              </MenuItem>

              <MenuItem
                name="4-2"
                to="/shopManage"
                v-if="b_role.indexOf('backend/shopManage') != -1"
              >
                <i class="circle-icon"></i>
                <span>店櫃管理</span>
              </MenuItem>

              <MenuItem
                name="4-3"
                to="/scanSign"
                v-if="b_role.indexOf('backend/scanSign') != -1"
              >
                <i class="circle-icon"></i>
                <span>簽收掃描</span>
              </MenuItem>

              <!-- <MenuItem name="4-4" to="/scanSpecial" v-if="b_role.indexOf('backend/scanSpecial') != -1">
                         <i class="circle-icon"></i>
                         <span>特殊掃描</span>
                     </MenuItem> -->

              <MenuItem
                name="4-5"
                to="/signTodo"
                v-if="b_role.indexOf('backend/signTodo') != -1"
              >
                <i class="circle-icon"></i>
                <span>未簽收</span>
              </MenuItem>

              <MenuItem
                name="4-13"
                to="/signTodoNew2"
                v-if="b_role.indexOf('backend/signTodoNew2') != -1"
              >
                <i class="circle-icon"></i>
                <span>未簽收（new）</span>
              </MenuItem>

              <MenuItem
                name="4-12"
                to="/signTodoCount"
                v-if="b_role.indexOf('backend/signTodoCount') != -1"
              >
                <i class="circle-icon"></i>
                <span>未簽收統計</span>
              </MenuItem>

              <MenuItem
                name="4-6"
                to="/signed"
                v-if="b_role.indexOf('backend/signed') != -1"
              >
                <i class="circle-icon"></i>
                <span>已簽收</span>
              </MenuItem>

              <MenuItem
                name="4-7"
                to="/stockscanIn"
                v-if="b_role.indexOf('backend/stockscanIn') != -1"
              >
                <i class="circle-icon"></i>
                <span>記錄掃描</span>
              </MenuItem>

              <MenuItem
                name="4-8"
                to="/stockscanInList"
                v-if="b_role.indexOf('backend/stockscanInList') != -1"
              >
                <i class="circle-icon"></i>
                <span>記錄掃描列表</span>
              </MenuItem>

              <MenuItem
                name="4-9"
                to="/overtimeList"
                v-if="b_role.indexOf('backend/overtimeList') != -1"
              >
                <i class="circle-icon"></i>
                <span>超時件列表</span>
              </MenuItem>

              <MenuItem
                name="4-11"
                to="/transferWaiting"
                v-if="b_role.indexOf('backend/transferWaiting') != -1"
              >
                <i class="circle-icon"></i>
                <span>待轉店列表</span>
              </MenuItem>

              <MenuItem
                name="4-10"
                to="/transferConfirm"
                v-if="b_role.indexOf('backend/transferConfirm') != -1"
              >
                <i class="circle-icon"></i>
                <span>轉入本店確認</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="5"
              v-if="
                b_role.indexOf('backend/financeDetail') != -1 ||
                b_role.indexOf('backend/saleDetail') != -1 ||
                b_role.indexOf('backend/deliverDetail') != -1 ||
                b_role.indexOf('backend/customsDoc') != -1 ||
                b_role.indexOf('backend/payInfo') != -1 ||
                b_role.indexOf('backend/traffic') != -1 ||
                b_role.indexOf('backend/dailyCount') != -1 ||
                b_role.indexOf('backend/dailyCountStore') != -1 ||
                b_role.indexOf('backend/notOnshelf') != -1 ||
                b_role.indexOf('backend/notOnshelf2') != -1 ||
                b_role.indexOf('backend/notOnshelfCount') != -1 ||
                b_role.indexOf('backend/abnormalCount') != -1 ||
                b_role.indexOf('backend/forecast') != -1 ||
                b_role.indexOf('backend/instorelist') != -1 ||
                b_role.indexOf('backend/returnedItems') != -1 ||
                b_role.indexOf('backend/kpiPackages') != -1
              "
            >
              <template slot="title">
                <div>報表統計</div>
              </template>

              <MenuItem
                name="5-1"
                to="/financeDetail"
                v-if="b_role.indexOf('backend/financeDetail') != -1"
              >
                <i class="circle-icon"></i>
                <span>財務明細</span>
              </MenuItem>

              <MenuItem
                name="5-2"
                to="/saleDetail"
                v-if="b_role.indexOf('backend/saleDetail') != -1"
              >
                <i class="circle-icon"></i>
                <span>銷售明細</span>
              </MenuItem>

              <MenuItem
                name="5-3"
                to="/deliverDetail"
                v-if="b_role.indexOf('backend/deliverDetail') != -1"
              >
                <i class="circle-icon"></i>
                <span>出貨明細</span>
              </MenuItem>

              <MenuItem
                name="5-4"
                to="/customsDoc"
                v-if="b_role.indexOf('backend/customsDoc') != -1"
              >
                <i class="circle-icon"></i>
                <span>報關資料</span>
              </MenuItem>

              <MenuItem
                name="5-5"
                to="/payInfo"
                v-if="b_role.indexOf('backend/payInfo') != -1"
              >
                <i class="circle-icon"></i>
                <span>支付明細</span>
              </MenuItem>

              <MenuItem
                name="5-6"
                to="/traffic"
                v-if="b_role.indexOf('backend/traffic') != -1"
              >
                <i class="circle-icon"></i>
                <span>統計圖表</span>
              </MenuItem>

              <MenuItem
                name="5-7"
                to="/dailyCount"
                v-if="b_role.indexOf('backend/dailyCount') != -1"
              >
                <i class="circle-icon"></i>
                <span>快遞統計</span>
              </MenuItem>

              <MenuItem
                name="5-13"
                to="/dailyCount2"
                v-if="b_role.indexOf('backend/dailyCount') != -1"
              >
                <i class="circle-icon"></i>
                <span>快遞統計(年)</span>
              </MenuItem>

              <MenuItem
                name="5-8"
                to="/dailyCountStore"
                v-if="b_role.indexOf('backend/dailyCountStore') != -1"
              >
                <i class="circle-icon"></i>
                <span>快遞統計(門店)</span>
              </MenuItem>

              <MenuItem
                name="5-12"
                to="/notOnshelfCount"
                v-if="b_role.indexOf('backend/notOnshelf') != -1"
              >
                <i class="circle-icon"></i>
                <span>未上架報表</span>
              </MenuItem>

              <MenuItem
                name="5-10"
                to="/abnormalCount"
                v-if="b_role.indexOf('backend/abnormalCount') != -1"
              >
                <i class="circle-icon"></i>
                <span>門店異常錄入報表</span>
              </MenuItem>

              <MenuItem
                name="5-11"
                to="/forecast"
                v-if="b_role.indexOf('backend/forecast') != -1"
              >
                <i class="circle-icon"></i>
                <span>預報報表</span>
              </MenuItem>

              <MenuItem
                name="5-14"
                to="/instorelist"
                v-if="b_role.indexOf('backend/instorelist') != -1"
              >
                <i class="circle-icon"></i>
                <span>已入庫報表</span>
              </MenuItem>

              <MenuItem
                name="5-15"
                to="/returnedItems"
                v-if="b_role.indexOf('backend/returnedItems') != -1"
              >
                <i class="circle-icon"></i>
                <span>本地退報表</span>
              </MenuItem>

              <!--<MenuItem
                name="5-17"
                to="/kpiPackages"
                v-if="b_role.indexOf('backend/kpiPackages') != -1"
              >
                <i class="circle-icon"></i>
                <span>KPI追蹤</span>
              </MenuItem>-->
            </Submenu>

            <Submenu
              name="6"
              v-if="
                b_role.indexOf('backend/integralLog') != -1 ||
                b_role.indexOf('backend/integralNewLog') != -1 ||
                b_role.indexOf('backend/credit') != -1 ||
                b_role.indexOf('backend/creditOffline') != -1 ||
                b_role.indexOf('backend/creditTypeSetting') != -1
              "
            >
              <template slot="title">
                <div>積分管理</div>
              </template>

              <MenuItem
                name="6-1"
                to="/integralLog"
                v-if="b_role.indexOf('backend/integralLog') != -1"
              >
                <i class="circle-icon"></i>
                <span>積分日誌(舊)</span>
              </MenuItem>

              <MenuItem
                name="6-2"
                to="/integralNewLog"
                v-if="b_role.indexOf('backend/integralNewLog') != -1"
              >
                <i class="circle-icon"></i>
                <span>積分日誌</span>
              </MenuItem>

              <MenuItem
                name="6-3"
                to="/credit"
                v-if="b_role.indexOf('backend/credit') != -1"
              >
                <i class="circle-icon"></i>
                <span>線上積分設置</span>
              </MenuItem>

              <MenuItem
                name="6-4"
                to="/creditOffline"
                v-if="b_role.indexOf('backend/creditOffline') != -1"
              >
                <i class="circle-icon"></i>
                <span>門店積分設置</span>
              </MenuItem>

              <MenuItem
                name="6-5"
                to="/creditTypeSetting"
                v-if="b_role.indexOf('backend/creditTypeSetting') != -1"
              >
                <i class="circle-icon"></i>
                <span>贈送類型設置</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="7"
              v-if="
                b_role.indexOf('backend/userList') != -1 ||
                b_role.indexOf('backend/userStatistics') != -1
              "
            >
              <template slot="title">
                <div>會員管理</div>
              </template>

              <MenuItem
                name="7-1"
                to="/userList"
                v-if="b_role.indexOf('backend/userList') != -1"
              >
                <i class="circle-icon"></i>
                <span>會員列表</span>
              </MenuItem>

              <MenuItem
                name="7-2"
                to="/userStatistics"
                v-if="b_role.indexOf('backend/userStatistics') != -1"
              >
                <i class="circle-icon"></i>
                <span>會員統計</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="8"
              v-if="
                b_role.indexOf('backend/adminList') != -1 ||
                b_role.indexOf('backend/adminLog') != -1 ||
                b_role.indexOf('backend/samecityMasterlist') != -1
                // || b_role.indexOf('backend/samecityChildlist') != -1
              "
            >
              <template slot="title">
                <div>權限管理</div>
              </template>

              <MenuItem
                name="8-1"
                to="/samecityMasterlist"
                v-if="b_role.indexOf('backend/samecityMasterlist') != -1"
              >
                <i class="circle-icon"></i>
                <span>公司列表</span>
              </MenuItem>

              <MenuItem
                name="8-2"
                to="/adminList"
                v-if="b_role.indexOf('backend/adminList') != -1"
              >
                <i class="circle-icon"></i>
                <span>管理員列表</span>
              </MenuItem>

              <MenuItem
                name="8-3"
                to="/adminLog"
                v-if="b_role.indexOf('backend/adminLog') != -1"
              >
                <i class="circle-icon"></i>
                <span>管理員日誌</span>
              </MenuItem>

              <!-- <MenuItem name="8-4" to="/samecityChildlist"
                               v-if="b_role.indexOf('backend/samecityChildlist') != -1">
                         <i class="circle-icon"></i>
                         <span>同城用戶(子列表)</span>
                     </MenuItem> -->
            </Submenu>

            <Submenu
              name="9"
              v-if="
                b_role.indexOf('backend/bannerSetting') != -1 ||
                b_role.indexOf('backend/setCustomDoc') != -1 ||
                b_role.indexOf('backend/shelfManage') != -1 ||
                // b_role.indexOf('backend/deliverHome') != -1 ||
                b_role.indexOf('backend/version') != -1 ||
                b_role.indexOf('backend/articleManage') != -1 ||
                b_role.indexOf('backend/appNotificationManage') != -1 ||
                b_role.indexOf('backend/advertiserManage') != -1 ||
                b_role.indexOf('backend/complaintManage') != -1
              "
            >
              <template slot="title">
                <div>後臺設置</div>
              </template>

              <MenuItem
                name="9-1"
                to="/bannerSetting"
                v-if="b_role.indexOf('backend/bannerSetting') != -1"
              >
                <i class="circle-icon"></i>
                <span>Banner設置</span>
              </MenuItem>

              <MenuItem
                name="9-2"
                to="/setCustomDoc"
                v-if="b_role.indexOf('backend/setCustomDoc') != -1"
              >
                <i class="circle-icon"></i>
                <span>品名管理</span>
              </MenuItem>

              <MenuItem
                name="9-3"
                to="/shelfManage"
                v-if="b_role.indexOf('backend/shelfManage') != -1"
              >
                <i class="circle-icon"></i>
                <span>架號管理</span>
              </MenuItem>

              <MenuItem
                name="9-4"
                to="/version"
                v-if="b_role.indexOf('backend/version') != -1"
              >
                <i class="circle-icon"></i>
                <span>版本更新</span>
              </MenuItem>

              <MenuItem
                name="9-5"
                to="/articleManage"
                v-if="b_role.indexOf('backend/articleManage') != -1"
              >
                <i class="circle-icon"></i>
                <span>文章管理</span>
              </MenuItem>

              <MenuItem
                name="9-6"
                to="/appNotificationManage"
                v-if="b_role.indexOf('backend/appNotificationManage') != -1"
              >
                <i class="circle-icon"></i>
                <span>APP通知管理</span>
              </MenuItem>

              <MenuItem
                name="9-7"
                to="/advertiserManage"
                v-if="b_role.indexOf('backend/advertiserManage') != -1"
              >
                <i class="circle-icon"></i>
                <span>啟動廣告管理</span>
              </MenuItem>

              <MenuItem
                name="9-8"
                to="/complaintManage"
                v-if="b_role.indexOf('backend/complaintManage') != -1"
              >
                <i class="circle-icon"></i>
                <span>投訴類型設置</span>
              </MenuItem>
              <MenuItem
                name="9-10"
                to="/customFees"
                v-if="b_role.indexOf('backend/customFees') != -1"
              >
                <i class="circle-icon"></i>
                <span>追加费用</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="10"
              v-if="
                b_role.indexOf('backend/signedtochange') != -1 ||
                b_role.indexOf('backend/signOrderManage') != -1 ||
                b_role.indexOf('backend/feedback') != -1 ||
                b_role.indexOf('backend/customerRegister') != -1 ||
                b_role.indexOf('backend/allgoodsigntodo') != -1 ||
                b_role.indexOf('backend/allgoodrecycle') != -1 ||
                b_role.indexOf('backend/integralrecord') != -1 ||
                b_role.indexOf('backend/jifenoo') != -1
              "
            >
              <template slot="title">
                <div>客服專區</div>
              </template>

              <MenuItem
                name="10-1"
                to="/signedtochange"
                v-if="b_role.indexOf('backend/signedtochange') != -1"
              >
                <i class="circle-icon"></i>
                <span>未簽收(全部)</span>
              </MenuItem>

              <MenuItem
                name="10-2"
                to="/signOrderManage"
                v-if="b_role.indexOf('backend/signOrderManage') != -1"
              >
                <i class="circle-icon"></i>
                <span>已簽收(全部)</span>
              </MenuItem>

              <MenuItem
                name="10-3"
                to="/feedback"
                v-if="b_role.indexOf('backend/feedback') != -1"
              >
                <i class="circle-icon"></i>
                <span>問題反饋</span>
              </MenuItem>

              <MenuItem
                name="10-4"
                to="/customerRegister"
                v-if="b_role.indexOf('backend/customerRegister') != -1"
              >
                <i class="circle-icon"></i>
                <span>會員註冊</span>
              </MenuItem>

              <MenuItem
                name="10-5"
                to="/allgoodsigntodo"
                v-if="b_role.indexOf('backend/allgoodsigntodo') != -1"
              >
                <i class="circle-icon"></i>
                <span>全部快件</span>
              </MenuItem>

              <MenuItem
                name="10-6"
                to="/allgoodrecycle"
                v-if="b_role.indexOf('backend/allgoodrecycle') != -1"
              >
                <i class="circle-icon"></i>
                <span>回收站</span>
              </MenuItem>

              <MenuItem
                name="10-10"
                to="/jifenoo"
                v-if="b_role.indexOf('backend/jifenoo') != -1"
              >
                <i class="circle-icon"></i>
                <span>积分为0列表</span>
              </MenuItem>

              <MenuItem
                name="10-7"
                to="/integralrecord"
                v-if="b_role.indexOf('backend/integralrecord') != -1"
              >
                <i class="circle-icon"></i>
                <span>APP充值記錄</span>
              </MenuItem>

              <MenuItem
                name="10-8"
                to="/packageFo"
                v-if="b_role.indexOf('backend/packageFo') != -1"
              >
                <i class="circle-icon"></i>
                <span>包裹預報</span>
              </MenuItem>

              <MenuItem
                name="10-11"
                to="/expressInterception"
                v-if="b_role.indexOf('backend/expressInterception') != -1"
              >
                <i class="circle-icon"></i>
                <span>包裹拦截</span>
              </MenuItem>

              <MenuItem
                name="10-12"
                to="/importExcel"
                v-if="b_role.indexOf('backend/importExcel') != -1"
              >
                <i class="circle-icon"></i>
                <span>Excel入库</span>
              </MenuItem>
              <!--              <MenuItem
                name="10-9"
                to="/claimConfirmation"
                v-if="b_role.indexOf('backend/claimConfirmation') != -1"
              >
                <i class="circle-icon"></i>
                <span>认领件确认</span>
              </MenuItem>-->
            </Submenu>

            <Submenu
              name="11"
              v-if="
                b_role.indexOf('backend/setDelivery') != -1 ||
                b_role.indexOf('backend/deliverSigntodo') != -1 ||
                b_role.indexOf('backend/deliverSigned') != -1
                // b_role.indexOf('backend/deliverPending') != -1 ||
                // b_role.indexOf('backend/deliverTransit') != -1 ||
                // b_role.indexOf('backend/deliverShipped') != -1 ||
              "
            >
              <template slot="title">
                <div>送貨上門</div>
              </template>

              <MenuItem
                name="11-1"
                to="/setDelivery"
                v-if="b_role.indexOf('backend/setDelivery') != -1"
              >
                <i class="circle-icon"></i>
                <span>設置送貨上門</span>
              </MenuItem>

              <MenuItem
                name="11-2"
                to="/deliverSigntodo"
                v-if="b_role.indexOf('backend/deliverSigntodo') != -1"
              >
                <i class="circle-icon"></i>
                <span>送貨上門(未簽收)</span>
              </MenuItem>

              <MenuItem
                name="11-3"
                to="/deliverSigned"
                v-if="b_role.indexOf('backend/deliverSigned') != -1"
              >
                <i class="circle-icon"></i>
                <span>送貨上門(已簽收)</span>
              </MenuItem>

              <!-- <MenuItem name="11-4" to="/deliverPending" v-if="b_role.indexOf('backend/deliverPending') != -1">
                         <i class="circle-icon"></i>
                         <span>待配送訂單</span>
                     </MenuItem>
                     <MenuItem name="11-5" to="/deliverTransit" v-if="b_role.indexOf('backend/deliverTransit') != -1">
                         <i class="circle-icon"></i>
                         <span>配送中訂單</span>
                     </MenuItem>
                     <MenuItem name="11-6" to="/deliverShipped" v-if="b_role.indexOf('backend/deliverShipped') != -1">
                         <i class="circle-icon"></i>
                         <span>已配送訂單</span>
                     </MenuItem> -->
            </Submenu>

            <Submenu
              name="12"
              v-if="
                b_role.indexOf('backend/jpointSetting') != -1 ||
                b_role.indexOf('backend/jpointLog') != -1
                // || b_role.indexOf('backend/jpointRecommend') != -1
              "
            >
              <template slot="title">
                <div>集金幣管理</div>
              </template>

              <MenuItem
                name="12-1"
                to="/jpointSetting"
                v-if="b_role.indexOf('backend/jpointSetting') != -1"
              >
                <i class="circle-icon"></i>
                <span>集金幣設置</span>
              </MenuItem>

              <MenuItem
                name="12-2"
                to="/jpointLog"
                v-if="b_role.indexOf('backend/jpointLog') != -1"
              >
                <i class="circle-icon"></i>
                <span>集金幣日誌</span>
              </MenuItem>

              <!-- <MenuItem name="12-3" to="/jpointRecommend"
                               v-if="b_role.indexOf('backend/jpointRecommend') != -1">
                         <i class="circle-icon"></i>
                         <span>集金幣推薦</span>
                     </MenuItem> -->
            </Submenu>

            <Submenu
              name="14"
              v-if="
                b_role.indexOf('backend/samecityScanin') != -1 ||
                b_role.indexOf('backend/samecityMultiScanin') != -1 ||
                b_role.indexOf('backend/samecityList') != -1 ||
                b_role.indexOf('backend/samecityListToDo') != -1 ||
                b_role.indexOf('backend/samecityListSigned') != -1
              "
            >
              <template slot="title">
                <div>同城配送</div>
              </template>

              <MenuItem
                name="14-1"
                to="/samecityScanin"
                v-if="b_role.indexOf('backend/samecityScanin') != -1"
              >
                <i class="circle-icon"></i>
                <span>本地入件(單件)</span>
              </MenuItem>

              <MenuItem
                name="14-2"
                to="/samecityMultiScanin"
                v-if="b_role.indexOf('backend/samecityMultiScanin') != -1"
              >
                <i class="circle-icon"></i>
                <span>本地入件(多件)</span>
              </MenuItem>

              <MenuItem
                name="14-3"
                to="/samecityList"
                v-if="b_role.indexOf('backend/samecityList') != -1"
              >
                <i class="circle-icon"></i>
                <span>交收記錄</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="15"
              v-if="
                b_role.indexOf('backend/eventList') != -1 ||
                b_role.indexOf('backend/LotteryLog') != -1 ||
                b_role.indexOf('backend/eventLog') != -1
              "
            >
              <template slot="title">
                <div>活動</div>
              </template>

              <MenuItem
                name="15-1"
                to="/eventList"
                v-if="b_role.indexOf('backend/eventList') != -1"
              >
                <i class="circle-icon"></i>
                <span>活動列表</span>
              </MenuItem>

              <MenuItem
                name="15-2"
                to="/LotteryLog"
                v-if="b_role.indexOf('backend/LotteryLog') != -1"
              >
                <i class="circle-icon"></i>
                <span>積分支付抽獎日誌</span>
              </MenuItem>

              <MenuItem
                name="15-3"
                to="/eventLog"
                v-if="b_role.indexOf('backend/eventLog') != -1"
              >
                <i class="circle-icon"></i>
                <span>活動詳情</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="16"
              v-if="b_role.indexOf('backend/franchiseList') != -1"
            >
              <template slot="title">
                <div>加盟</div>
              </template>

              <MenuItem
                name="16-1"
                to="/franchiseList"
                v-if="b_role.indexOf('backend/franchiseList') != -1"
              >
                <i class="circle-icon"></i>
                <span>加盟收集列表</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="17"
              v-if="
                b_role.indexOf('backend/deliveryareaTodo') != -1 ||
                b_role.indexOf('backend/deliveryareaIng') != -1 ||
                b_role.indexOf('backend/deliveryareaDone') != -1 ||
                b_role.indexOf('backend/deliveryareaSetting') != -1 ||
                b_role.indexOf('backend/deliveryareaaddressSetting') != -1 ||
                b_role.indexOf('backend/deliveryareatimeSetting') != -1 ||
                b_role.indexOf('backend/deliveryareanotdutySetting') != -1 ||
                b_role.indexOf('backend/deliveryareaLimit') != -1
              "
            >
              <template slot="title">
                <div>派送專線</div>
              </template>

              <MenuItem
                name="17-1"
                to="/deliveryareaTodo"
                v-if="b_role.indexOf('backend/deliveryareaTodo') != -1"
              >
                <i class="circle-icon"></i>
                <span>待派送訂單</span>
              </MenuItem>

              <MenuItem
                name="17-2"
                to="/deliveryareaIng"
                v-if="b_role.indexOf('backend/deliveryareaIng') != -1"
              >
                <i class="circle-icon"></i>
                <span>派送中訂單</span>
              </MenuItem>

              <MenuItem
                name="17-3"
                to="/deliveryareaDone"
                v-if="b_role.indexOf('backend/deliveryareaDone') != -1"
              >
                <i class="circle-icon"></i>
                <span>已派送訂單</span>
              </MenuItem>

              <MenuItem
                name="17-4"
                to="/deliveryareaSetting"
                v-if="b_role.indexOf('backend/deliveryareaSetting') != -1"
              >
                <i class="circle-icon"></i>
                <span>派送專線設定</span>
              </MenuItem>
              <MenuItem
                name="17-5"
                to="/deliveryareaLimit"
                v-if="b_role.indexOf('backend/deliveryareaLimit') != -1"
              >
                <i class="circle-icon"></i>
                <span>派送限制設定</span>
              </MenuItem>

              <!-- <MenuItem name="17-5" to="/deliveryareaaddressSetting" v-if="b_role.indexOf('backend/deliveryareaaddressSetting') != -1">
                         <i class="circle-icon"></i>
                         <span>派送大廈設定</span>
                     </MenuItem>

                     <MenuItem name="17-6" to="/deliveryareatimeSetting" v-if="b_role.indexOf('backend/deliveryareatimeSetting') != -1">
                         <i class="circle-icon"></i>
                         <span>派送時間設定</span>
                     </MenuItem>

                     <MenuItem name="17-8" to="/deliveryareanotdutySetting" v-if="b_role.indexOf('backend/deliveryareanotdutySetting') != -1">
                         <i class="circle-icon"></i>
                         <span>不派送日期選擇設定</span>
                     </MenuItem> -->
            </Submenu>

            <Submenu
              name="18"
              v-if="
                b_role.indexOf('backend/zhuhaiInventory') != -1 ||
                b_role.indexOf('backend/macaoInventory') != -1 ||
                b_role.indexOf('backend/shopInventory') != -1
              "
            >
              <template slot="title">
                <div>快遞記錄</div>
              </template>

              <MenuItem
                name="18-1"
                to="/zhuhaiInventory"
                v-if="b_role.indexOf('backend/zhuhaiInventory') != -1"
              >
                <i class="circle-icon"></i>
                <span>珠海倉記錄</span>
              </MenuItem>

              <MenuItem
                name="18-2"
                to="/macaoInventory"
                v-if="b_role.indexOf('backend/macaoInventory') != -1"
              >
                <i class="circle-icon"></i>
                <span>澳門倉記錄</span>
              </MenuItem>

              <MenuItem
                name="18-3"
                to="/shopInventory"
                v-if="b_role.indexOf('backend/shopInventory') != -1"
              >
                <i class="circle-icon"></i>
                <span>門店記錄</span>
              </MenuItem>
            </Submenu>

            <Submenu
              name="19"
              v-if="
                b_role.indexOf('backend/commodityList') != -1 ||
                b_role.indexOf('backend/commodityAdd') != -1 ||
                b_role.indexOf('backend/commodityEdit') != -1 ||
                b_role.indexOf('backend/appbanneradvertiserManage') != -1
              "
            >
              <template slot="title">
                <div>好物兌換商品</div>
              </template>

              <MenuItem
                name="19-1"
                to="/commodityList"
                v-if="b_role.indexOf('backend/commodityList') != -1"
              >
                <i class="circle-icon"></i>
                <span>好物兌換商品列表</span>
              </MenuItem>

              <MenuItem
                name="19-2"
                to="/commodityAdd"
                v-if="b_role.indexOf('backend/commodityAdd') != -1"
              >
                <i class="circle-icon"></i>
                <span>添加好物商品</span>
              </MenuItem>

              <!--<MenuItem name="19-3" to="/appbanneradvertiserManage" v-if="b_role.indexOf('backend/appbanneradvertiserManage') != -1">
                         <i class="circle-icon"></i>
                         <span>好物APP圖示設置</span>
                     </MenuItem>-->
              <MenuItem
                name="19-4"
                to="/commodityTypes"
                v-if="b_role.indexOf('backend/commodityTypes') != -1"
              >
                <i class="circle-icon"></i>
                <span>好物商品類型</span>
              </MenuItem>

              <MenuItem
                name="19-7"
                to="/couponRedemptionList"
                v-if="b_role.indexOf('backend/couponRedemptionList') != -1"
              >
                <i class="circle-icon"></i>
                <span>优惠卷兑换列表</span>
              </MenuItem>

              <MenuItem
                name="19-6"
                to="/commoDiscounts"
                v-if="b_role.indexOf('backend/commoDiscounts') != -1"
              >
                <i class="circle-icon"></i>
                <span>兑换商家绑定</span>
              </MenuItem>

              <MenuItem
                name="19-5"
                to="/recommendedManage"
                v-if="b_role.indexOf('backend/recommended') != -1"
              >
                <i class="circle-icon"></i>
                <span>APP推薦模塊管理</span>
              </MenuItem>
            </Submenu>

            <Submenu name="20" v-if="b_role.indexOf('backend/orderList') != -1">
              <template slot="title">
                <div>好物兌換訂單</div>
              </template>

              <MenuItem
                name="20-1"
                to="/orderList"
                v-if="b_role.indexOf('backend/orderList') != -1"
              >
                <i class="circle-icon"></i>
                <span>好物兌換訂單列表</span>
              </MenuItem>
            </Submenu>

            <Submenu name="21" v-if="b_role.indexOf('backend/btbList') != -1">
              <template slot="title">
                <div>BTB模块</div>
              </template>

              <MenuItem
                name="21-1"
                to="/btbList"
                v-if="b_role.indexOf('backend/btbList') != -1"
              >
                <i class="circle-icon"></i>
                <span>BTB列表</span>
              </MenuItem>
            </Submenu>
          </Menu>
        </vue-scroll>
      </Sider>
      <Layout>
        <Header class="layout-header">
          <div class="left">
            <Icon
              @click.native="collapsedSider"
              type="md-menu"
              size="22"
            ></Icon>
          </div>
          <div class="right">
            <div class="search-box" v-if="b_role.indexOf('backend/home') != -1">
              <Input
                style="margin-right: 20px"
                v-model="keyword"
                placeholder="請輸入快遞單號/手機號"
                clearable
                icon="ios-search"
                class="search-inp"
                @keyup.enter.native="handleSearchBtn"
              />
              <Button
                @click="handleSearchBtn"
                icon="ios-search"
                class="search-btn"
                type="primary"
                >查詢快件
              </Button>
            </div>
            <div class="user-avatar">
              <img :src="logInfo.avatar" alt="" />
            </div>
            <div class="user-name">
              <span>{{ logInfo.username }}</span>
            </div>
            <div class="user-name">
              <span
                style="color: red; margin-left: 10px; cursor: pointer"
                @click="logout"
              >
                退出</span
              >
            </div>
          </div>
        </Header>
        <Content class="layout-main">
          <div class="layout-m-inner">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>

            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </div>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
var isthis;
export default {
  name: "navFrame",
  props: {},
  data() {
    console.log(process.env);
    return {
      env: process.env,
      keyword: "",
      b_role: [],
      logInfo: {},
      scrollOption: {
        bar: {
          background: "rgba(144, 147, 153, .3)",
        },
      },
      isCollapsed: false,
      activeMenuName: "1-1", //集運幫->登入頁面
      menuRoute: {
        //---------------頁面------------------
        "/home": "1-1", //查詢快件
        "/homeDetail": "1-1", //查詢快件->快遞信息
        //---------------珠海倉庫------------------
        "/scanIn": "2-1", //珠海倉庫->掃描入庫
        "/scanIn2": "2-8", //珠海倉庫->掃描入庫
        "/scanInMerchant": "2-11", //珠海倉庫->掃描入庫 合作方
        "/scanInMerchantBig": "2-12", //珠海倉庫->掃描入庫 合作方
        "/scanInBig": "2-13", //珠海倉庫->掃描入庫 转店
        "/scanInMore": "2-7", //珠海倉庫->多件掃描入庫
        "/scanOut": "2-2", //珠海倉庫->掃描出庫
        "/deliverTodo": "2-3", //珠海倉庫->待出庫
        "/deliverTodoEdit": "2-3", //珠海倉庫->待出庫->修改
        "/delivered": "2-4", //珠海倉庫->已出庫
        "/deliveredEdit": "2-4", //珠海倉庫->已出庫->修改
        "/logisticsInfo": "2-4", //珠海倉庫->已出庫-物流信息
        "/deliverExc": "2-5", //珠海倉庫->異常件
        "/deliverExcEdit": "2-5", //珠海倉庫->異常件->修改
        "/ExclogisticsInfo": "2-5", //珠海倉庫->異常件->物流信息
        "/deliverClaim": "2-6", //珠海倉庫->認領件
        "/bagNumberList": "2-9", //珠海倉庫->大包号列表
        "/pddList": "2-14", //珠海倉庫->pdd
        "/claimConfirmation": "2-10", //珠海倉庫->認領件確認
        //----------------澳門倉庫------------------
        "/macaoScanIn": "3-1", //澳門倉庫->掃描入庫
        "/macaoScanOut": "3-2", //澳門倉庫->掃描出庫
        "/macaoScanInList": "3-3", //澳門倉庫->已入庫
        "/macaoScanOutList": "3-4", //澳門倉庫->已出庫
        "/abnormalList": "3-5", //澳門倉庫->異常件列表
        "/overtimeTaking": "3-6", //澳門倉庫->超時件攬收
        "/overtimeWarehouse": "3-7", //澳門倉庫->超時快件回倉
        "/overtimeCancel": "3-8", //澳門倉庫->超時快件核銷
        "/transferList": "3-9", //澳門倉庫->轉店列表
        //----------------澳門門店------------------
        "/shopOnShelves": "4-1", //澳門門店->門店上架
        "/shopManage": "4-2", //澳門門店->門店管理
        "/shopManageAdd": "4-2", //澳門門店->門店管理->增加
        "/shopManageEdit": "4-2", //澳門門店->門店管理->修改
        "/scanSign": "4-3", //澳門門店->簽收掃描
        // '/scanSpecial': '4-4', //澳門門店->特殊掃描
        "/signTodo": "4-5", //澳門門店->未簽收
        "/signTodoNew2": "4-13", //澳門門店->未簽收
        "/signTodoCount": "4-12", //澳門門店->未簽收统计
        "/shopSignetodoRemark": "4-5", //澳門門店->未簽收->備註
        "/shopUserIntegral": "4-5", //澳門門店->未簽收->會員信息
        "/shopSigntodologisticsInfo": "4-5", //澳門門店->未簽收->物流信息
        "/signed": "4-6", //澳門門店->已簽收
        "/shopSignedRemark": "4-6", //澳門門店->已簽收->備註
        "/shopSignedlogisticsInfo": "4-6", //澳門門店->已簽收->物流信息
        "/stockscanIn": "4-7", //澳門門店->記錄掃描
        "/stockscanInList": "4-8", //澳門門店->記錄掃描列表
        "/overtimeList": "4-9", //澳門門店->超時件列表
        "/transferConfirm": "4-10", //澳門門店->轉入本店確認
        "/transferWaiting": "4-11", //澳門門店->待轉店列表
        //---------------財務報表------------------
        "/financeDetail": "5-1", //財務報表->財務明細
        "/saleDetail": "5-2", //財務報表->銷售明細
        "/deliverDetail": "5-3", //財務報表->出貨明細
        "/customsDoc": "5-4", //財務報表->報關資料
        "/payInfo": "5-5", //財務報表->支付明細
        "/traffic": "5-6", //財務報表->統計圖表
        "/dailyCount": "5-7", //財務報表->快遞統計(全局)
        "/dailyCount2": "5-13", //財務報表->快遞統計(全局)
        "/dailyCountStore": "5-8", //財務報表->快遞統計(門店)
        "/notOnshelf": "5-9", //財務報表->未上架報表
        "/notOnshelf2": "5-15", //財務報表->未上架報表
        "/notOnshelfCount": "5-12", //財務報表->未上架報表
        "/abnormalCount": "5-10", //財務報表->門店異常錄入報表
        "/forecast": "5-11", //財務報表->預報報表
        "/instorelist": "5-14", //財務報表->預報報表
        "/returnedItems": "5-16", //財務報表->本地退
        "/kpiPackages": "5-17", //財務報表->kpi
        //----------------積分管理-------------------
        "/integralLog": "6-1", //積分管理->積分日誌(舊)
        "/integralNewLog": "6-2", //積分管理->積分日誌
        "/credit": "6-3", //積分管理->線上積分設置
        "/creditEdit": "6-3", //積分管理->線上積分設置->新增/修改
        "/creditOffline": "6-4", //積分管理->門店積分設置
        "/creditEditOffline": "6-4", //積分管理->門店積分設置->新增/修改
        "/creditTypeSetting": "6-5", //積分管理->贈送類型設置
        "/creditTypeSettingEdit": "6-5", //積分管理->贈送類型設置->修改
        //-----------------會員管理-------------------
        "/userList": "7-1", //會員管理->會員列表
        "/userEdit": "7-1", //會員管理->會員列表->修改
        "/userIntegral": "7-1", //會員管理->會員列表->積分操作
        "/userStatistics": "7-2", //會員管理->會員統計
        "/addUser": "7-3", //會員管理->新增会员
        //-----------------同城配送-----------------
        "/samecityMasterlist": "8-1", //同城配送->公司列表
        "/samecityMasterlistAdd": "8-1", //同城配送->公司列表->增加
        "/samecityMasterlistEdit": "8-1", //同城配送->公司列表->修改
        // '/samecityChildlist': '8-4', //同城配送->同城用戶列表(子號)
        // '/samecityChildlistAdd': '8-4', //同城配送->同城用戶列表(子號)->增加
        // '/samecityChildlistEdit': '8-4', //同城配送->同城用戶列表(子號)->修改
        //-----------------管理員管理-----------------
        "/adminList": "8-2", //管理員管理->管理員列表
        "/adminAdd": "8-2", //管理員管理->管理員列表->增加
        "/adminEdit": "8-2", //管理員管理->管理員列表->修改
        "/adminRole": "8-2", //管理員管理->管理員列表->分派權限
        "/adminLog": "8-3", //管理員管理->管理員日誌
        //-----------------後臺管理-----------------
        "/bannerSetting": "9-1", //後臺管理->Banner設置
        "/bannerSettingAdd": "9-1", //後臺管理->Banner設置->增加
        "/bannerSettingEdit": "9-1", //後臺管理->Banner設置->修改
        "/setCustomDoc": "9-2", //後臺管理->品名管理
        "/setCustomDocEdit": "9-2", //後臺管理->品名管理->修改
        "/shelfManage": "9-3", //後臺管理->架號管理
        "/shelfManageEdit": "9-3", //後臺管理->架號管理->修改
        "/version": "9-4", //後臺管理->版本更新
        "/versionEdit": "9-4", //後臺管理->版本更新->修改
        "/articleManage": "9-5", //後臺管理->文章管理
        "/articleManageAdd": "9-5", //後臺管理->文章管理->增加
        "/articleManageEdit": "9-5", //後臺管理->文章管理->修改
        "/appNotificationManage": "9-6", //後臺管理->APP通知管理
        "/appNotificationManageAdd": "9-6", //後臺管理->APP通知管理->增加
        "/appNotificationManageEdit": "9-6", //後臺管理->APP通知管理->修改
        "/advertiserManage": "9-7", //後臺管理->啟動廣告設定
        "/advertiserManageEdit": "9-7", //後臺管理->啟動廣告設定->修改
        "/advertiserManageAdd": "9-7", //後臺管理->啟動廣告設定->增加
        "/complaintManage": "9-8", //後臺管理->投訴類型設置
        "/complaintManageEdit": "9-8", //後臺管理->投訴類型設置->修改
        "/complaintManageAdd": "9-8", //後臺管理->投訴類型設置->增加
        "/recommendedAdd": "9-9", //後臺管理->app推薦模塊
        "/recommendedEdit": "9-9", //後臺管理->app推薦模塊
        "/customFees": "9-10", //後臺管理->追加费用
        //-----------------客服專區---------------------
        "/signedtochange": "10-1", //客服專區->未簽收(全部)
        "/signOrderManage": "10-2", //客服專區->已簽收(全部)
        "/feedback": "10-3", //客服專區->問題反饋
        "/feedbackedit": "10-3", //客服專區->問題反饋->修改
        "/customerRegister": "10-4", //客服專區->會員註冊
        "/allgoodsigntodo": "10-5", //客服專區->全部快件
        "/allgoodrecycle": "10-6", //客服專區->回收站
        "/integralrecord": "10-7", //客服專區->APP充值記錄
        "/packageFo": "10-8", //客服專區->APP充值記錄
        // '/claimConfirmation': '10-9', //客服專區->认领件确认
        "/jifenoo": "10-10", //客服專區->积分 0000
        "/expressInterception": "10-11", //客服專區->包裹拦截
        "/importExcel": "10-12", //客服專區->excel入库
        //-----------------送貨上門---------------------
        "/setDelivery": "11-1", //設置送貨上門
        "/deliverSigntodo": "11-2", //送貨上門(未簽收)
        "/deliverSigned": "11-3", //送貨上門(已簽收)
        // '/deliverPending': '11-4', //待配送訂單
        // '/deliverShipped': '11-5', //已配送訂單
        // '/deliverTransit': '11-6', //配送中訂單
        //------------------集金幣管理-------------------
        "/jpointSetting": "12-1", //集金幣管理->集金幣設置
        "/jpointSettingAdd": "12-1", //集金幣管理->集金幣設置->增加
        "/jpointSettingEdit": "12-1", //集金幣管理->集金幣設置->修改
        "/jpointLog": "12-2", //集金幣管理->集金幣日誌
        // '/jpointRecommend': '12-3', //集金幣管理->集金幣推薦
        //-------------------同城配送--------------------
        "/samecityScanin": "14-1", //同城配送->同城件入庫
        "/samecityMultiScanin": "14-2", //同城配送->同城多件
        "/samecityMultiScaninEdit": "14-2", //同城配送->同城多件->修改
        "/samecityList": "14-3", //同城配送->同城交收記錄
        "/samecityListToDo": "14-3", //同城配送->同城交收記錄
        "/samecityListSigned": "14-3", //同城配送->同城交收記錄
        "/samecityListShop": "14-3", //同城配送->同城交收記錄
        "/samecityScaninEdit": "14-3", //同城配送->同城交收記錄->修改
        //----------------------活動--------------------
        "/eventList": "15-1", //活動->活動列表
        "/eventListEdit": "15-1", //活動->活動列表->修改
        "/eventListAdd": "15-1", //活動->活動列表->新增
        "/LotteryLog": "15-2", //活動->積分支付抽獎日誌
        "/eventLog": "15-3", //活動->活動詳情
        //----------------------加盟--------------------
        "/franchiseList": "16-1", //加盟->加盟列表
        //----------------------派送專線--------------------
        "/deliveryareaTodo": "17-1", //派送專線->待派送訂單
        "/deliveryareaIng": "17-2", //派送專線->派送中訂單
        "/deliveryareaDone": "17-3", //派送專線->已派送訂單
        "/deliveryareaSetting": "17-4", //派送專線->派送設定
        "/deliveryareaaddressSetting": "17-4", //派送專線->派送地址設定
        "/deliveryareatimeSetting": "17-4", //派送專線->派送時間設定
        "/deliveryareabuildingtimeSetting": "17-4", //派送專線->派送大廈時間設定
        "/deliveryareanotdutySetting": "17-4", //派送專線->不派送日期選擇設定
        "/deliveryareaLimit": "17-5", //派送專線->不派送日期選擇設定
        //----------------------快遞記錄(珠海倉)--------------------
        "/zhuhaiInventory": "18-1", //快遞記錄->珠海倉記錄
        "/zhuhaiInventoryGrid": "18-1", //快遞記錄->珠海倉記錄->自提點件數
        "/zhuhaiInventoryRecord": "18-1", //快遞記錄->珠海倉記錄->差異記錄
        "/zhuhaiInventoryRecordDetail": "18-1", //快遞記錄->珠海倉記錄->差異記錄->詳情
        //----------------------快遞記錄(澳門倉)--------------------
        "/macaoInventory": "18-2", //快遞記錄->澳門倉記錄
        "/macaoInventoryGrid": "18-2", //快遞記錄->澳門倉記錄->自提點件數
        "/macaoInventoryRecord": "18-2", //快遞記錄->澳門倉記錄->差異記錄
        "/macaoInventoryRecordDetail": "18-2", //快遞記錄->澳門倉記錄->差異記錄->詳情
        //----------------------快遞記錄(門店)--------------------
        "/shopInventory": "18-3", //快遞記錄->門店倉記錄
        "/shopInventoryGrid": "18-3", //快遞記錄->門店記錄->自提點件數
        "/shopInventoryRecord": "18-3", //快遞記錄->門店記錄->差異記錄
        "/shopInventoryRecordDetail": "18-3", //快遞記錄->門店記錄->差異記錄->詳情
        //----------------------商品--------------------
        "/commodityList": "19-1", //商品->商品列表
        "/commodityAdd": "19-2", //商品->添加商品
        "/commodityEdit": "19-1", //商品->修改商品
        "/appbanneradvertiserManage": "19-3", //商品->商品區域設置
        "/appbanneradvertiserManageAdd": "19-3", //商品->商品區域設置->增加
        "/appbanneradvertiserManageEdit": "19-3", //商品->商品區域設置->修改
        "/commodityTypes": "19-4", //商品->商品區域設置->商品分類
        "/recommendedManage": "19-5", //->app推薦模塊
        "/commoDiscounts": "19-6", //->app推薦模塊
        "/couponRedemptionList": "19-7", //->app推薦模塊
        //----------------------訂單--------------------
        "/orderList": "20-1", //訂單->訂單列表
        "/orderdetailedList": "20-1", //訂單->訂單列表->訂單詳情
        // ----------------------btb--------------------
        "/btbList": "21-1",
      },
    };
  },
  computed: {
    openMenuName() {
      let activeMenuName = this.activeMenuName;
      let openNames = activeMenuName.slice("-")[0];
      return [openNames];
    },
  },
  created() {
    isthis = this;
    this.setCurActiveMenu(this.$route.path);
    this.b_role = this.$store.state.logInfo.b_role;
    this.logInfo = this.$store.state.logInfo;
  },
  watch: {
    $route(to, from) {
      this.setCurActiveMenu(to.path);
    },
  },
  methods: {
    handleSearchBtn() {
      let keyword = this.keyword;
      if (!keyword) {
        this.$Message.warning("請輸入快遞單號或電話號碼");
        return false;
      }

      this.$store.commit("setKeyWord", keyword);
      if (this.$route.name == "home") {
        return false;
      }
      this.$router.push({ path: "/home" });
    },
    collapsedSider() {
      this.$refs.menuSider.toggleCollapse();
    },
    setCurActiveMenu(path) {
      this.activeMenuName = this.menuRoute[path];
    },
    logout() {
      this.$store.commit("cleatLogInfo");
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="scss">
.page-nav-frame {
  min-width: 1080px;
  height: 100%;

  .pg-layout {
    height: 100%;

    > .layout-left {
      height: 100%;
      background: #fff;
      position: relative;
      z-index: 11;
      box-shadow: 3px 0px 6px rgba(255, 104, 104, 0.05);
    }

    .layout-l-header {
      .dev-label {
        display: inline-block;
        vertical-align: middle;
        margin-top: 16px;
        font-size: 24px;
        color: #fff;
        background: #f00;
        padding: 2px 5px;
        border-radius: 2px;
      }

      .version-label {
        font-size: 16px;
        color: #ff466b;
        padding: 6px 0;
        font-weight: bold;
      }

      .logo {
        padding: 0 0 10px 0;
        text-align: center;
        margin-bottom: 12px;

        img {
          vertical-align: middle;
          width: 90px;
        }
      }
    }

    .layout-l-menu {
      z-index: 1;
    }

    /* reset menu */
    .ivu-menu-vertical.ivu-menu-light:after {
      display: none;
    }

    .ivu-menu-vertical .ivu-menu-item,
    .ivu-menu-vertical .ivu-menu-submenu-title {
      text-align: left;
      padding: 8px 16px;
      font-size: 15px;
      font-weight: 400;
      color: #333;
    }

    .ivu-menu-submenu {
      .ivu-menu-item {
        padding-left: 25px !important;
        font-size: 14px;

        .circle-icon {
          display: inline-block;
          vertical-align: middle;
          width: 10px;
          height: 10px;
          margin-right: 12px;
          border: 1px solid #999999;
          border-radius: 50%;
        }

        > span {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }

    .ivu-menu-vertical .ivu-menu-submenu-title-icon {
      right: 5px;
      transform: translateY(-50%) rotate(-90deg);
    }

    .ivu-menu-opened .ivu-menu-submenu-title-icon {
      transform: translateY(-50%) rotate(0deg);
    }

    .ivu-menu-light.ivu-menu-vertical
      .ivu-menu-item-active:not(.ivu-menu-submenu) {
      background: #ff6565;
      color: #fff;

      .circle-icon {
        border-color: #fff;
      }

      &:after {
        display: none;
      }
    }

    .ivu-menu-vertical .ivu-menu-item:hover,
    .ivu-menu-vertical .ivu-menu-submenu-title:hover {
      color: #ff6565;

      .circle-icon {
        border-color: #ff6565;
      }
    }

    /*** 右側頭部 ****/
    .layout-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      height: 50px;
      line-height: normal;
      background: #fff;
      position: relative;
      z-index: 10;
      box-shadow: 0px 3px 6px rgba(255, 104, 104, 0.05);

      > .left {
        color: #999999;

        i {
          cursor: pointer;
        }
      }

      > .right {
        display: flex;
        align-items: center;

        .search-box {
          display: flex;
          margin-right: 50px;

          .search-inp {
            width: 250px;
          }

          .search-btn {
            margin-left: 16px;
          }
        }

        .user-avatar {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          background: #f5f5f5;
          border-radius: 50%;
          overflow: hidden;
          position: relative;

          img {
            position: absolute;
            top: 50%;
            left: 0;
            display: block;
            width: 100%;
            transform: translateY(-50%);
          }
        }

        .user-name {
          font-size: 14px;
          color: #333333;
        }
      }
    }

    /*** main ***/
    .layout-main {
      flex: 1;
      overflow: hidden;
      text-align: left;

      .layout-m-inner {
        padding: 20px;
        height: 100%;
        background: #f9f5f5;
        overflow: auto;
        box-sizing: border-box;
      }
    }
  }
}
</style>
